<template>
  <div class="s_layout_siderbar_item">
    <el-menu-item v-if="!item.children" :index="basePath">
      <SvgIcon v-if="item.icon" :name="item.icon"/>
      <span slot="title">{{ item.title }}</span>
    </el-menu-item>
    <el-submenu v-else :index="basePath">
      <template slot="title">
        <SvgIcon v-if="item.icon" :name="item.icon"/>
        <span slot="title">{{ item.title }}</span>
      </template>
      <LayoutSidebarItem v-for="menu in item.children" :key="menu.id" :item="menu" :base-path="resolvePath(menu.path)"/>
    </el-submenu>
  </div>
</template>

<script>
import path from 'path'
export default {
  name: "LayoutSidebarItem",
  props: {
    item: {
      type: Object,
      required: true,
    },
    basePath: {
      type: String,
      default: "",
    },
  },
  created() {
    // console.log(path.resolve('/chat', 'chatson'))
  },
  methods: {
    resolvePath(routePath) {
      if(this.$global.isExternal(routePath)){
          return routePath
      }
      return path.resolve(this.basePath, routePath)
    }
  },
};
</script>
<style lang="scss">
.s_layout_siderbar_item {
  .el-menu-item {
    padding: 0px !important;
    font-size: 22px;
    .svg-icon {
      color: $menuText;
    }
    &.is-active {
      background: $meauActiveBg !important;
      .svg-icon {
       color: $white;
      }
    }
  }
}
</style>
